module.exports = __webpack_public_path__ + "img/advantage3_2@2x.953b4b0d.png";